import { i18nReady } from './i18n'

// Los textos del idioma llegan en un chunk aparte (ver i18n.js) y el store
// traduce al importarse: la app se evalúa recién cuando están. En modo "eager"
// el código sigue en el bundle inicial, sin un request extra.
i18nReady.then(() => import(/* webpackMode: "eager" */ './app-main'))
